class TemplateBlogArticleJS {
    constructor() {
        // Custom code for blog/article page goes here
        var prevousUrl=document.referrer
        if (prevousUrl != "" && prevousUrl.includes('/recipes/tagged')) {
            var category=prevousUrl.split('tagged/')[1];
            if (document.querySelector('[data-previous-category]') != null) {
                category=category.split('cat_')[1].replaceAll('-',' ');
                category=category.split('?')[0]
                document.querySelector('[data-previous-category]').innerHTML=category.replaceAll('amp','&');
            }
            document.querySelector('[data-back-button="all-recipe"]')?.classList.add('d-none');
            document.querySelector('[data-back-button="single-recipe"]')?.classList.remove('d-none');
        }else{
            document.querySelector('[data-back-button="all-recipe"]')?.classList.remove('d-none');
            document.querySelector('[data-back-button="single-recipe"]')?.classList.add('d-none');
        }
    }
}

typeof TemplateBlogArticleJS !== 'undefined' && new TemplateBlogArticleJS();
